module.exports = __webpack_public_path__ + "img/116024.976f8db5.png";